import { SxStyle } from '../../types/style';

const contentBox: SxStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};

const contentBoxStack: SxStyle = {
    marginRight: '16px'
};

const contentButton: SxStyle = {
    width: '130px'
};

export const datepickerStyle = {
    contentBox,
    contentBoxStack,
    contentButton
};